/**
 * @generated SignedSource<<b9b39b07bf56ad31c1c3d1a28791c1c9>>
 * @relayHash 423919d13d57653b2e9c3769e68f2b09
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8179a69028770ff58fa99c72360f926b70fb1edb5f40282d66611c913a793e9a

import type { ConcreteRequest } from 'relay-runtime';
export type PageTreeMacroRootLevelQuery$variables = {
  spaceKey: string;
};
export type PageTreeMacroRootLevelQuery$data = {
  readonly ptpage: {
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly id: string;
        readonly lastUpdatedDate: {
          readonly value: string;
        } | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly id: string;
    readonly lastUpdatedDate: {
      readonly value: string;
    } | null;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly title: string | null;
  } | null;
};
export type PageTreeMacroRootLevelQuery = {
  response: PageTreeMacroRootLevelQuery$data;
  variables: PageTreeMacroRootLevelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v4 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MILLIS"
  }
],
v5 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v6 = {
  "args": (v4/*: any*/),
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v7 = {
  "args": (v4/*: any*/),
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "lastUpdatedDate",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
},
v8 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v9 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          },
          {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageTreeMacroRootLevelQuery",
    "selections": (v9/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageTreeMacroRootLevelQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "423919d13d57653b2e9c3769e68f2b09",
    "id": "8179a69028770ff58fa99c72360f926b70fb1edb5f40282d66611c913a793e9a",
    "metadata": {},
    "name": "PageTreeMacroRootLevelQuery",
    "operationKind": "query",
    "text": "query PageTreeMacroRootLevelQuery($spaceKey:String!){ptpage(spaceKey:$spaceKey){id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui},followingSiblings{nodes{id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage}}}}"
  }
};
})();

(node as any).hash = "719bdc5b722e95ed2bdf030fecc89213";

export default node;
